// native
import { Injectable } from '@angular/core';

// service
import { ApiService } from './api.service';
import { GlobalsService } from './globals.service';

// constants
import { DEFAULT_LANGUAGE, DEFAULT_LOCALE, LOCALES } from '../../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  constructor(
    private apiService: ApiService,
    private globalsService: GlobalsService
  ) { }

  setLanguageAndLocale(language: string): Promise<void> {
    if (!language) {
      this.setDefaultLanguageAndLocale();
      return;
    }

    const url = `${this.globalsService.appConfig.environment.baseUrls.smartciteAssets}/locales/locales-${language}.xml`;

    return this.apiService.getTextFile(url).then(locale => {
      if (locale) {
        this.globalsService.language = language;
        this.globalsService.locale = locale;
      } else {
        this.setDefaultLanguageAndLocale();
      }
    }).catch(() => {
      this.setDefaultLanguageAndLocale();
    });
  }

  private setDefaultLanguageAndLocale() {
    this.globalsService.language = DEFAULT_LANGUAGE;
    this.globalsService.locale = DEFAULT_LOCALE;
  }

  getLocaleList(): { id: string, name: string; }[] {
    const localeList: { id: string, name: string; }[] = [];
    const names = LOCALES['language-names'];

    for (const key in names) {
      localeList.push({
        id: key,
        name: names[key][1] || names[key][0]
      });
    }

    localeList.sort((a, b) => {
      return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });

    return localeList;
  }
}
